// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kN6os","content":"styles_content__t2kXl","tableWrap":"styles_tableWrap__2jMJt"};